import React, { Component } from "react";
import Modal from "react-modal";
import "../common.css";
import { MdClose } from "react-icons/md";
import utilityFunctions from "@store/utilityFunctions";
import axios from "axios";
import SelectOption from "@components/Select/SelectOption";
import config from "@config";

Modal.setAppElement("body");
const countryOptions = [
  { value: "AU", label: "Australia" },
  { value: "NZ", label: "New Zealand" },
];

export default class ServiceCenterSettingAdd extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      redirect: false,
      statusTicket: "",
      modalStatusConfirm: false,
      brands: [],
      roles: [],
      currentRole: "",
      serviceCenterOptions: null,
      serviceCenterValue: this.props.serviceCenterValue,
      locationOptions: null,
      locationValue: this.props.locationValue,
      siteValue: this.props.siteValue,

      postError: "",
      countryValue: countryOptions.find((c) => c.value === config.country),
    };
  }

  serviceCenterChange = (sc) => {
    this.setState({ serviceCenterValue: sc, locationValue: null });
  };

  siteChange = (sc) => {
    this.setState({ siteValue: sc });
  };

  addServiceCenterSetting = (payload) => {
    const userInfo =
      localStorage?.getItem("userInfo") ||
      utilityFunctions?.getCookie("userInfo");
    const token = (userInfo && JSON?.parse(userInfo)?.access_token) || "";
    let options = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };
    return new Promise((resolve) => {
      axios
        .post(
          `${config.backendServer}default-service-center/`,
          payload,
          options
        )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          resolve(err);
        });
    });
  };

  updateServiceCenterSetting = (payload) => {
    const userInfo =
      localStorage?.getItem("userInfo") ||
      utilityFunctions?.getCookie("userInfo");
    const token = (userInfo && JSON?.parse(userInfo)?.access_token) || "";
    let options = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };
    return new Promise((resolve) => {
      axios
        .patch(
          `${config.backendServer}default-service-center/${this.props.serviceCenterValue.value}/`,
          payload,
          options
        )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          resolve(err);
        });
    });
  };

  handleSubmit = async (event) => {
    this.setState({ loading: true });
    event.preventDefault();

    let payload = {
      country: this.state.countryValue.value,
      site_domain: config.baseUrl,
      service_center_central: this.state.serviceCenterValue.value,
      service_center: this.state.locationValue.value,
    };

    const result = this.props.serviceCenterValue.value
      ? await this.updateServiceCenterSetting(payload)
      : await this.addServiceCenterSetting(payload);
    if (result.status === 200 || result.status === 201) {
      this.setState({ loading: false });
      this.props.closeModal();
      this.props.retrieveDefaultServiceCenter();
    } else {
      this.setState({
        loading: false,
        postError: JSON.stringify(result?.response?.data),
      });
    }
  };

  handleChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  render() {
    return (
      <div className={"card"} style={{ height: "100%" }}>
        <button
          onClick={() => this.props.closeModal()}
          className={"confirm-modal-close"}
        >
          <MdClose />
        </button>
        <div className={"card-header"}>
          <h4>{`${
            this.state.serviceCenterValue.value
              ? "Edit Service Center"
              : "Add Service Center"
          } `}</h4>
        </div>

        <form onSubmit={this.handleSubmit}>
          <div className="card-body m-3">
            <div className="mb-3">
              <label
                className={"single-warranty-details-label "}
                htmlFor="name"
              >
                Service Center*
              </label>
              <SelectOption
                apiEndpoint={
                  config.backendServer + "service_center_central/dropdown/"
                }
                isDisabled={Boolean(this.props.serviceCenterValue.value)}
                options={this.state.serviceCenterOptions}
                value={this.state.serviceCenterValue}
                onChange={(sc) => this.serviceCenterChange(sc)}
              />
            </div>
            <div className="mb-3">
              <label className={"single-warranty-details-label"}>
                Location*
              </label>
              <SelectOption
                apiEndpoint={
                  config.backendServer +
                  `service_center_central/${this.state.serviceCenterValue.value}/location/`
                }
                options={this.state.locationOptions}
                value={this.state.locationValue}
                onChange={(sc) => this.setState({ locationValue: sc })}
              />
            </div>
            <div className="mb-3">
              <label className={"single-warranty-details-label"}>Site</label>
              <input
                className="form-control "
                value={config.baseUrl}
                disabled
              />
            </div>

            <div className="mb-3">
              <label className={"single-warranty-details-label"}>Country</label>
              <input
                className="form-control "
                value={this.state.countryValue.label}
                disabled
              />
            </div>
          </div>
          <div className="card-footer ">
            <div className="d-flex justify-content-start gap-2">
              <button className={"btn btn-outline-primary"}>Submit</button>
              <button
                type="button"
                className={"btn btn-outline-secondary"}
                onClick={() => this.props.closeModal()}
              >
                Close
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}
